import {Box} from "@mui/material";
import styles from "../Utilities/templateStyles";
import CreateTemplateForm from "./CreateTemplateForm";

export default function AdminCreateTemplate() {

    return (
        <>
            <Box sx={styles.root}>
                <Box sx={styles.container}>
                    <Box sx={styles.containerBody}>
                        <Box sx={styles.header}>
                            Create template
                        </Box>
                        <CreateTemplateForm />
                    </Box>
                </Box>
            </Box>
        </>
    )
}